import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import StartPage from '@/pages/start/StartPage';
import CookieConsentManager from '@/components/cookies/CookieConsentManager';
import AttributionTracker from '@/components/AttributionTracker';
import { trackAnalyticsPageView } from '@/lib/analytics';

// The ad landing page needs neither the dashboard providers nor its UI libraries.
export default function StartApp() {
  const { pathname, search } = useLocation();

  useEffect(() => {
    document.documentElement.dataset.pageReady = pathname;
    trackAnalyticsPageView();
    window.scrollTo(0, 0);
    return () => { delete document.documentElement.dataset.pageReady; };
  }, [pathname, search]);

  return <>
    <AttributionTracker />
    <StartPage />
    <div data-cookie-consent-root><CookieConsentManager /></div>
  </>;
}
